'use strict';

exports.__esModule = true;
exports.refComparatorDesc = exports.refComparator = exports.eventComparatorDesc = exports.eventComparator = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var IHeap = function () {
  function IHeap(primary, secondary) {
    _classCallCheck(this, IHeap);

    this.iters = new Array(1);
    this.primary = primary;
    this.secondary = secondary;
  }

  IHeap.prototype._less = function _less(i, j) {
    var ii = this.iters[i].op || _ron.ZERO;
    var jj = this.iters[j].op || _ron.ZERO;
    var c = this.primary(ii, jj);
    if (c === 0 && this.secondary) {
      c = this.secondary(ii, jj);
    }
    return c < 0;
  };

  IHeap.prototype._sink = function _sink(i) {
    var to = i;
    var j = i << 1;
    if (j < this.iters.length && this._less(j, i)) {
      to = j;
    }
    j++;

    if (j < this.iters.length && this._less(j, to)) {
      to = j;
    }

    if (to !== i) {
      this._swap(i, to);
      this._sink(to);
    }
  };

  IHeap.prototype._raise = function _raise(i) {
    var j = i >> 1;
    if (j > 0 && this._less(i, j)) {
      this._swap(i, j);
      if (j > 1) {
        this._raise(j);
      }
    }
  };

  IHeap.prototype._swap = function _swap(i, j) {
    var memo = this.iters[i];
    this.iters[i] = this.iters[j];
    this.iters[j] = memo;
  };

  IHeap.prototype.put = function put(input) {
    var batch = input instanceof _ron.Batch ? input : new _ron.Batch(input);
    for (var _iterator = batch, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var item = _ref;

      var cursor = new _ron.Cursor(item.body);
      while (cursor.op && !cursor.op.isRegular()) {
        cursor.next();
      }if (cursor.op && cursor.op.isRegular()) {
        var at = this.iters.length;
        this.iters.push(cursor);
        this._raise(at);
      }
    }
  };

  IHeap.prototype.current = function current() {
    return this.iters.length > 1 ? this.iters[1].op : null;
  };

  IHeap.prototype._remove = function _remove(i) {
    if (this.iters.length === 2 && i === 1) {
      this.clear();
    } else {
      if (this.iters.length - 1 === i) {
        this.iters.pop();
      } else {
        this.iters.splice(i, 1, this.iters.pop());
      }
      this._sink(i);
    }
  };

  IHeap.prototype._next = function _next(i) {
    this.iters[i].next();
    if (!this.iters[i].op || this.iters[i].op.isHeader()) {
      this._remove(i);
    } else {
      this._sink(i);
    }
  };

  IHeap.prototype.next = function next() {
    this._next(1);
    return this.current();
  };

  IHeap.prototype.eof = function eof() {
    return this.iters.length <= 1;
  };

  IHeap.prototype.clear = function clear() {
    this.iters = new Array(1);
  };

  IHeap.prototype.frame = function frame() {
    var cur = new _ron.Frame();
    while (!this.eof()) {
      var op = this.current();
      if (op) {
        cur.push(op);
      }
      this.next();
    }
    return cur;
  };

  IHeap.prototype.nextPrim = function nextPrim() {
    var eqs = [];
    this._listEqs(1, eqs);
    if (eqs.length > 1) {
      eqs.sort();
    }
    for (var i = eqs.length - 1; i >= 0; i--) {
      this._next(eqs[i]);
      // this._sink(eqs[i]);
    }
    return this.current();
  };

  IHeap.prototype._listEqs = function _listEqs(at, eqs) {
    eqs.push(at);
    var l = at << 1;
    if (l < this.iters.length) {
      if (0 === this.primary(this.iters[1].op || _ron.ZERO, this.iters[l].op || _ron.ZERO)) {
        this._listEqs(l, eqs);
      }
      var r = l | 1;
      if (r < this.iters.length) {
        if (0 === this.primary(this.iters[1].op || _ron.ZERO, this.iters[r].op || _ron.ZERO)) {
          this._listEqs(r, eqs);
        }
      }
    }
  };

  _createClass(IHeap, [{
    key: 'length',
    get: function get() {
      return this.iters.length;
    }
  }]);

  return IHeap;
}();

exports.default = IHeap;


function comparator(n) {
  var desc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (desc) args.reverse();
    return args[0].uuid(n).compare(args[1].uuid(n));
  };
}

var eventComparator = exports.eventComparator = comparator(2);
var eventComparatorDesc = exports.eventComparatorDesc = comparator(2, true);
var refComparator = exports.refComparator = comparator(3);
var refComparatorDesc = exports.refComparatorDesc = comparator(3, true);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/rdt/lib/iheap.js
// module id = 16
// module chunks = 0